import React from 'react';
import ImagingToggles, { ImagingToggleProps } from './ImagingTools';
import {
  useShowOverlays,
  useShowScaleBar,
  useShowWellDropInfoPanel,
} from 'redux/hooks/experiment';

const AnnotationToggles = () => {
  const [showScaleBar, toggleScaleBar] = useShowScaleBar();
  const [showOverlays, toggleOverlays] = useShowOverlays();
  const [showWellDropInfoPanel, toggleWellDropInfoPanel] = useShowWellDropInfoPanel();

  const annotationToggles: ImagingToggleProps[] = [
    {
      label: 'Scale Bar',
      isOn: showScaleBar,
      onToggle: toggleScaleBar,
      disabled: false,
    },
    {
      label: 'Annotation',
      isOn: showOverlays,
      onToggle: toggleOverlays,
      disabled: false,
    },
    {
      label: 'Info',
      isOn: showWellDropInfoPanel,
      onToggle: toggleWellDropInfoPanel,
      disabled: false,
    },
  ];
  return <ImagingToggles toggles={annotationToggles} />;
};

export default AnnotationToggles;
